/**
 * The key to what is highlighted in the rendered document.
 *
 * variant="guidance" — explains the sky highlight + 〔Gn〕 marker
 * variant="fields"   — explains the green fillable-field highlight
 *
 * MOVED HERE 2026-09-03, from cases/checkpoints/. It used to sit beneath an
 * inline HTML preview on the templates page; that preview is now the viewer
 * panel, so the key was stranded on a page no longer showing the thing it
 * describes. It belongs beside the render it explains — which also stops the
 * universal viewer importing a component out of `cases/checkpoints`.
 *
 * The colours it names are baked into the PDF server-side by
 * `GET /api/v2/templates/:id/preview.pdf` (highlightSectionsDocx +
 * highlightMarkersDocx), so this stays in sync with that route, not with any
 * client-side overlay CSS.
 */

export function PreviewLegend({ variant }: { variant: 'guidance' | 'fields' }) {
  return (
    <div className="mt-2 flex flex-wrap items-center gap-3 text-[11px] text-muted">
      <span className="font-medium text-content">Key:</span>
      {variant === 'guidance' ? (
        <>
          <span className="flex items-center gap-1">
            <span
              className="inline-block h-3 w-4 rounded-sm"
              style={{ background: 'rgba(2,132,199,0.18)' }}
            />
            Drafted with authority guidance
          </span>
          <span className="flex items-center gap-1">
            <sup style={{ color: '#0284c7', fontWeight: 600 }}>〔G1〕</sup>{' '}
            Guidance source — hover for detail (see the Guidance panel)
          </span>
        </>
      ) : (
        <>
          <span className="flex items-center gap-1">
            <span className="inline-block h-3 w-4 rounded-sm bg-green-200" />
            Detected fillable field
          </span>
          <span className="flex items-center gap-1">
            <span
              className="inline-block h-3 w-4 rounded-sm"
              style={{ borderLeft: '3px solid #7c3aed', background: '#ede9fe' }}
              aria-hidden
            />
            Detected section
          </span>
        </>
      )}
    </div>
  );
}
